import { Link } from '@sortlist-frontend/design-system';
import { Fragment } from 'react';

import type { RankingRichText } from '../types';
import { uniqueKeys } from '../utils/uniqueKeys';

interface RichTextProps {
  text: RankingRichText;
}

export const RichText = (props: RichTextProps) => {
  const { text } = props;
  const keys = uniqueKeys(text.map((part) => (typeof part === 'string' ? part : part.text)));

  return (
    <Fragment>
      {text.map((part, index) => {
        const key = keys[index];
        if (typeof part === 'string') {
          return <Fragment key={key}>{part}</Fragment>;
        }
        if ('strong' in part) {
          return (
            <strong key={key} className="font-semibold text-secondary-950">
              {part.text}
            </strong>
          );
        }
        return (
          <Link key={key} href={part.href} color="primary" underline="always">
            {part.text}
          </Link>
        );
      })}
    </Fragment>
  );
};
